import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';
import { ChickenTest } from './chicken-test';

@Injectable()
export class ChickenTestService {
  constructor(private dialog: MatDialog) {}

  /**
   *
   * @param {string} action - Action to be taken (Are you sure you want to {{Action}}?)
   * @param {string} positive - Label for positive button
   * @param {string} negative - Label for negative button
   * @param {string} noHeader - defaults to false, <h1> is left off if true
   * @returns {Observable<boolean>}
   */
  public test(action: string, positive: string, negative: string, noHeader?: boolean): Observable<boolean> {
    let dialogRef: MatDialogRef<ChickenTest>;

    dialogRef = this.dialog.open(ChickenTest);
    dialogRef.componentInstance.action = action;
    dialogRef.componentInstance.positive = positive;
    dialogRef.componentInstance.negative = negative;
    dialogRef.componentInstance.noHeader = noHeader ? noHeader : false;

    return dialogRef.afterClosed();
  }

  public cancel(positive: string, negative: string): Observable<boolean> {
    let dialogRef: MatDialogRef<ChickenTest>;
    dialogRef = this.dialog.open(ChickenTest);
    dialogRef.componentInstance.positive = positive;
    dialogRef.componentInstance.negative = negative;
    return dialogRef.afterClosed();
  }
}
